import React from "react";
import XLSX from "xlsx";
import moment from "moment";
import { Card, Button } from "antd";
import { MdSelectAll } from "react-icons/fa";
import TableRow from "./components/table_row";

import "./style.css";

export default class PagarParcelasFile extends React.Component {
  handleChange = e => {
    const files = e.target.files;
    if (files && files[0]) this.setState({ ...this.state, file: files[0] });
  };

  make_cols = refstr => {
    let o = [],
      C = XLSX.utils.decode_range(refstr).e.c + 1;
    for (var i = 0; i < C; ++i)
      o[i] = { name: XLSX.utils.encode_col(i), key: i };
    return o;
  };

  handleFile = async () => {
    /* Boilerplate to set up FileReader */
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;

    reader.onload = async e => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, {
        type: rABS ? "binary" : "array",
        bookVBA: true,
        locale: "pt-BR"
      });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      let data = XLSX.utils.sheet_to_json(ws, {
        cellDates: true,
        dateNF: "YYYY-MM-DD",
        raw: true
      });

      data.map(value => {
        console.log("1");
        console.log(value);
        //value['Dt.Receb.'] = moment((value['Dt.Receb.'] - (25567 + 1)) * 86400 * 1000).format('YYYY-MM-DD')
      });
      console.log(data);
      //console.log(data_aux.split('\n').slice(1))
      /*console.log(data_aux.split('\n').slice(1))
            data_aux = data_aux.split('\n').slice(1)
            for (var i = 0; i < data_aux.length; i++) {
                console.log(data_aux[i].split(','))
                let aux = ({
                    Pasta: data_aux[i].split(',')[0],
                    'Sinistro': data_aux[i].split(',')[1],
                    'Callcenter': data_aux[i].split(',')[2],
                    'Num.Parc': data_aux[i].split(',')[3],
                    'Dt.Venc.': data_aux[i].split(',')[4],
                    'Dt.Receb.': data_aux[i].split(',')[5],
                    'Vlr.Recebido': data_aux[i].split(',')[6],
                    'Vlr.Honor.': data_aux[i].split(',')[7],
                })
                console.log(aux)
                data.push(aux)
            }
            console.log(data)/*
            /* Update state */
      let linhas = [];
      this.setState({
        ...this.state,
        data: data,
        cols: this.make_cols(ws["!ref"])
      });
    };
    if (rABS) {
      reader.readAsBinaryString(this.state.file);
    } else {
      reader.readAsArrayBuffer(this.state.file);
    }
  };

  arruma_data = state => {
    let linhas = [];
    console.log(this.state);
    try {
      const dados = state.data;
      console.log(dados);
      dados.map(value => {
        value["Dt.Venc."] = moment(
          (value["Dt.Venc."] - (25567 + 1)) * 86400 * 1000
        ).format("YYYY-MM-DD");
        value["Dt.Receb."] = moment(
          (value["Dt.Receb."] - (25567 + 1)) * 86400 * 1000
        ).format("YYYY-MM-DD");
        linhas.push(value);
      });
      return linhas;
    } catch (err) {
      //console.log(err)
      return 0;
    }
  };

  handleOnClick = () => {
    if (this.state.checked == true)
      this.setState({ ...this.state, checked: false });
    else this.setState({ ...this.state, checked: true });
  };

  render() {
    const linhas = this.arruma_data(this.state);
    if (linhas == 0) {
      return (
        <React.Fragment>
          <br />
          <div className="div__input">
            <div className="cw__title">Importar planilha de pagamento</div>
            <br></br>
            <p>
              Aqui você importa uma planilha gerada a partir do email de
              pagamentos da HDI
            </p>
            O cabeçalho da da planilha deve vir como no email. Atualmente o
            cabeçalho é composto por:
            <br />
            <ul>
              <li>Pasta</li>
              <li>Sinistro</li>
              <li>Callcenter</li>
              <li>Num.Parc</li>
              <li>Dt.Venc.</li>
              <li>Dt.Receb.</li>
              <li>Vlr.Recebido</li>
              <li>Vlr.Honor.</li>
            </ul>
            As parcelas serão localizadas com base no número da pasta e o número
            da parcela.
            <br />
            <br />
            O acordo precisa estar com status "Ativo" para que a parcela seja
            localizada.
            <br />
            <br />
            <b>
              **EM CASO DE ALTERAÇÃO NO CABEÇALHO, FAVOR COMUNICAR O ADMIN POR
              EMAIL**
            </b>
            <div className="cw__inputs">
              <input
                type="file"
                className="ant-input"
                style={{ width: "30%" }}
                id="file"
                onChange={this.handleChange}
              />
              <br />
            </div>
            <div className="cw__inputs">
              <Button type="primary" onClick={this.handleFile}>
                Upload
              </Button>
            </div>
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <br></br>
          <Card>
            <table className="acordoview__table">
              <thead>
                <tr>
                  <th>Pasta</th>
                  <th>Tipo Acordo</th>
                  <th>Nº Parc</th>
                  <th>Valor Parc</th>
                  <th>Dt Venc</th>
                  <th>Dt Pgto</th>
                  <th>Valor Pago</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {linhas.map((value, index) => {
                  return <TableRow key={index} data={value} />;
                })}
              </tbody>
            </table>
            <br />
          </Card>
        </React.Fragment>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/Acordo/PagarParcelas/index.js